/**
 * 文字起こし要素内から highlight（タイムスタンプ）に一致する発話要素を探す。
 * `data-speaked-at` 属性が highlight と一致する最初の要素を返す。
 * 見つからない場合は null を返す。
 * 表示テキスト（textContent）ではなく属性値で特定するため、
 * テンプレート整形やパイプ追加による表示変更に影響されない。
 */
export function findSpeakElementByHighlight(
  transcriptElement: HTMLElement,
  highlight: string,
): HTMLElement | null {
  return transcriptElement.querySelector<HTMLElement>(
    `[data-speaked-at="${CSS.escape(highlight)}"]`,
  )
}
